import styled from 'styled-components';
import { FONT_STYLES } from '../../../../styles/common/font-styles';

const BannerContainer = styled.div`
  ${({ theme }) => theme.container.sidePadding}
  position: relative;
  height: 554px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url(${({ backgroundImg }) => backgroundImg});
  background-size: 100% 100%;
  background-repeat: no-repeat;
`;

const BannerTextContainer = styled.div`
  p:nth-child(1) {
    ${FONT_STYLES.P_B}
    font-size: 52px;
    padding-bottom: 35px;
  }
  p:nth-child(2) {
    ${FONT_STYLES.P_M}
    font-size: 24px;
  }
  color: white;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export { BannerContainer, BannerTextContainer };